module.exports = __webpack_public_path__ + "static/media/img_3.a77ab45f.png";